export default function Tabs(theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: '5px',
          borderRadius: '1em',
          backgroundColor: theme.palette.primary.main,
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: theme.typography.customFontSize[4],
          color: theme.palette.primary.greyThird,
          textTransform: 'none',
          minHeight: 46,
          '&:hover': {
            backgroundColor: theme.palette.primary.transparent,
            color: theme.palette.primary.greyPrimary,
          },
          '&.Mui-selected': {
            fontWeight: theme.typography.customFontWeight[3],
            color: theme.palette.primary.main,
          }
        }
      }
    }
  };
}
